import React from 'react';
import { Container } from 'react-bootstrap';

/**
 * Costing component that displays project cost information via embedded Google Sheets
 * @returns {JSX.Element} Costing component with embedded spreadsheet
 */
const Costing = () => {
    return (
        <Container>
            <h2 className="mb-4">Project Costing</h2>
            <div className="iframe-container" style={{ width: '100%', height: '700px' }}>
                <iframe
                    src="https://docs.google.com/spreadsheets/d/1i4ZyN-1AAFQVKYMF3yaa6hxo4OQ3PG7y/edit?gid=466725730#gid=466725730"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                    title="Project Costing Spreadsheet"
                    allowFullScreen
                />
            </div>
        </Container>
    );
};

export default Costing; 